var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98801 8.73856V8.73952L8.98833 8.73872C10.9381 8.65184 12.3941 8.31104 12.3941 7.90528C12.3941 7.49952 10.9387 7.15888 8.98833 7.072V8.4008C8.93233 8.40592 8.62721 8.4312 8.02033 8.4312C7.51505 8.4312 7.14897 8.4096 7.02097 8.4008V7.072C5.06689 7.15872 3.60801 7.49856 3.60801 7.90576C3.60801 8.31296 5.06673 8.65328 7.02097 8.73984V8.73824C7.14689 8.7448 7.50417 8.7592 8.01201 8.7592C8.64721 8.7592 8.93249 8.74208 8.98801 8.73856Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 3.58192 12.4181 0 8 0C3.58144 0 0 3.58096 0 8C0 12.419 3.58208 16 8 16C12.4179 16 16 12.4181 16 8ZM8.98737 5.744V6.93408L8.98801 6.9344C11.196 7.03632 12.8559 7.47408 12.8559 7.9984C12.8559 8.52272 11.196 8.96048 8.98801 9.0624V12.8747H7.02001V9.06272C4.80881 8.96048 3.14481 8.5224 3.14481 7.9976C3.14481 7.4728 4.80801 7.03472 7.02001 6.93312V5.744H4.29825V3.93072H11.7088V5.744H8.98737Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.f3b8dea55d9251571ddd3e47a65b6af1.svg";
export { ForwardRef as ReactComponent };